import styled from 'styled-components';
import { CaptionRegularL } from '../../../../../../styles/globals';
import { IThemeProvider } from '../../../../../../styles/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  min-height: 30rem;
  gap: 40px;
  padding: 2rem 0;
  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[0]};
    border-radius: ${theme.layout.spacing.decy};
  `}
`;

export const TopicLevelContainer = styled.div`
  width: 100%;
  padding: 0 6.5rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const InnerWrapper = styled.div`
  position: relative;
  max-width: 100%;
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

export const SwitchersWrapper = styled.div`
  display: flex;
`;

export const SwitcherBlock = styled.div<{ isActive: boolean }>`
  transition: 0.5s;
  width: ${({ isActive }) => (isActive ? '24px' : '16px')};
  height: 16px;
  border-radius: 24px;
  cursor: pointer;
  margin: 0 3px;
  background-color: ${({ isActive }) => (isActive ? '#5E7590' : '#BAC4D0')};
`;

export const Text = styled(CaptionRegularL)`
  ${({ theme }: IThemeProvider) => `
    margin: 0 0 ${theme.layout.spacing.centy};
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const SliderWrapper = styled.div`
  overflow: hidden;
  margin: 0 2rem;
  width: 100%;
  height: 100%;
`;

export const SliderContainer = styled.div<{ translateX: string }>`
  display: flex;
  width: 100%;
  transition: transform 0.5s ease-in-out;
  transform: translateX(${({ translateX }) => translateX});
`;

export const InnerContainer = styled.div`
  min-width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
`;

export const AllQuestionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TitleText = styled.div`
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 3rem;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const RowsBox = styled.div`
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 1rem;
`;

export const ScalesBox = styled.div`
  width: 100%;
  display: flex;
  height: 100%;
  margin-bottom: 1rem;
  justify-content: space-between;
`;

export const ArrowBtn = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  &:first-child {
    ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[0]};
  `}
  }
  span:hover {
    ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.secondary[10]};
  `}
  }
  span:active {
    ${({ theme }: IThemeProvider) => `
      background: ${theme.colors.secondary[30]};
    `}
  }
`;

export const LeftArrowBtn = styled(ArrowBtn)`
  top: 35px;
  ${({ theme }: IThemeProvider) => `
    left: ${theme.layout.spacing.centy};
  `}
`;

export const RightArrowBtn = styled(ArrowBtn)`
  top: 35px;
  ${({ theme }: IThemeProvider) => `
    right: ${theme.layout.spacing.centy};
  `}
`;

export const Flex = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TextLight = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
`;

export const InnerFlex = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;
